<template>
    <div :id="computed_id" 
        class="content" 
        role="tabpanel" 
        :aria-labelledby="computed_id+'-trigger'">
        <slot></slot>
    </div>
</template>

<script>
import Stepper from 'bs-stepper';
export default {
    props: [
        'id',
        'title',
    ],
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('step-' + this._uid);
            } else {
                return this.id;
            }
        },
    },
    mounted() {
        const vm = this;
        this.$emit('SteeperEntry', {
            id: vm.computed_id,
            title: vm.title ? vm.title : vm.computed_id,
        })

        this.$nextTick(function () {
            vm.$parent.$emit('SteeperEntry', {
                id: this.computed_id,
                title: this.title ? this.title : this.computed_id,
            });
        });
    },
    methods: {

    }
}
</script>